import {BaseApiTemplateService, Core2Config} from "../../../shared";
import {ProjectVirtualContactContainerModel} from "../../../../../../../models/aggregates/alg/cc/project/project-virtual-contact-container.model";
import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";

@Injectable({providedIn: 'root'})
export class ProjectVirtualContactService extends BaseApiTemplateService<ProjectVirtualContactContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_TEST_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'projects-virtual-contacts';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ALG_CC_MODULE + 'projects-virtual-contacts';
    this.httpClient = http;
  }
}
